import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import RbacAuditPermissionChips from './RbacAuditPermissionChips'
import {
  auditArrowTextSx,
  auditChangeRowSx,
  auditFieldLabelSx,
  auditPermissionLabelSx,
  auditPermissionRowSx,
  auditPrimaryTextSx,
  auditStrikeTextSx
} from './rbacAuditHistoryConstants'

function PermissionChangeRow({ change }) {
  const { fieldLabel, beforeActions = [], afterActions = [], kind = 'change' } = change

  if (kind === 'added') {
    return (
      <Box sx={auditPermissionRowSx}>
        <Typography sx={auditPermissionLabelSx}>{fieldLabel}:</Typography>
        <RbacAuditPermissionChips actions={afterActions} />
      </Box>
    )
  }

  if (kind === 'removed') {
    return (
      <Box sx={auditPermissionRowSx}>
        <Typography sx={auditPermissionLabelSx}>{fieldLabel}:</Typography>
        <RbacAuditPermissionChips actions={beforeActions} strikethrough />
      </Box>
    )
  }

  return (
    <Box sx={auditPermissionRowSx}>
      <Typography sx={auditPermissionLabelSx}>{fieldLabel}:</Typography>
      <RbacAuditPermissionChips actions={beforeActions} strikethrough />
      <Typography component="span" sx={auditArrowTextSx}>
        →
      </Typography>
      <RbacAuditPermissionChips actions={afterActions} />
    </Box>
  )
}

export default function RbacAuditChangeRow({ change }) {
  if (change?.changeType === 'permission') {
    return <PermissionChangeRow change={change} />
  }

  const { fieldLabel, before, after, kind = 'change' } = change

  if (kind === 'added') {
    return (
      <Box component="span" sx={auditChangeRowSx}>
        <Typography component="span" sx={auditFieldLabelSx}>
          {fieldLabel}:{' '}
        </Typography>
        <Typography component="span" sx={auditPrimaryTextSx}>
          {after}
        </Typography>
      </Box>
    )
  }

  if (kind === 'removed') {
    return (
      <Box component="span" sx={auditChangeRowSx}>
        <Typography component="span" sx={auditFieldLabelSx}>
          {fieldLabel}:{' '}
        </Typography>
        <Typography component="span" sx={auditStrikeTextSx}>
          {before}
        </Typography>
      </Box>
    )
  }

  return (
    <Box component="span" sx={auditChangeRowSx}>
      <Typography component="span" sx={auditFieldLabelSx}>
        {fieldLabel}:{' '}
      </Typography>
      {before ? (
        <Typography component="span" sx={auditStrikeTextSx}>
          {before}
        </Typography>
      ) : null}
      {before && after ? (
        <Typography component="span" sx={{ ...auditArrowTextSx, mx: '6px' }}>
          →
        </Typography>
      ) : null}
      {after ? (
        <Typography component="span" sx={auditPrimaryTextSx}>
          {after}
        </Typography>
      ) : null}
    </Box>
  )
}
